import React, { Component } from 'react';
import { MODAL_COLLABORATORS } from '../../util/enums/EnumModals';
import { validateEmail } from '../../util/helpers/string-helpers';
import ModalLoading from './ModalLoading';

class ModalCollaborators extends Component {
  static modalType() {
    return MODAL_COLLABORATORS;
  }

  static reducer(modals) {
    return modals.collaboratorsModal;
  }

  static title() {
    return (
      <span>
        <img src="/img/users.png" className="modal-top-icon" />
        Team access
      </span>
    );
  }

  componentDidMount() {
    this.focus();
  }

  focus() {
    setTimeout(() => {
      this._input.focus();
    }, 500);
  }

  render() {
    const { state, userInteraction } = this.props;

    if (state.saving) {
      return (
        <span>
          <ModalLoading /> Saving...
        </span>
      );
    }

    const emailChange = (e) => {
      const props = { section: 'email-change', newValue: e.target.value };
      userInteraction(props)();
    };
    const collabs = state.emails.map((email, index) => {
      const onClick = userInteraction({ section: 'toggle', email });
      const deleted =
        state.disabled.indexOf(email) === -1 ? '' : 'strike-through';
      const removeButton =
        deleted !== '' ? null : (
          <h5
            onClick={onClick}
            className="glyphicon glyphicon-remove user-clickable"
          />
        );
      const isAdmin = state.admins.indexOf(email) > -1;

      const role = isAdmin ? 'admin' : 'collaborator';
      function roleChange(e) {
        if (e.currentTarget.value !== role) {
          userInteraction({ section: 'toggleAdmin', email })();
        }
      }

      const activityPoints = state.activityPoints[index] ? (
        <small className="faint">
          ({state.activityPoints[index]} activity points)
        </small>
      ) : (
        ''
      );

      const roleButton =
        deleted !== '' ? (
          <button
            className="btn btn-xs margin-5 pull-right btn-danger"
            type="button"
            onClick={onClick}
          >
            deleted
          </button>
        ) : (
          <select
            value={role}
            className={`form-control input-sm pull-right role-${role}`}
            onChange={roleChange}
          >
            <option value="collaborator">collaborator</option>
            <option value="admin">admin</option>
          </select>
        );
      return (
        <tr key={email}>
          <td className="vertical-align-center">{roleButton}</td>
          <td className={deleted}>
            <h5 className="padding-left-10">
              {email} {activityPoints}
            </h5>
          </td>
          <td className="text-align-center">{removeButton}</td>
          <td />
        </tr>
      );
    });
    const addEnabled =
      state.email.length > 0 &&
      validateEmail(state.email) &&
      state.emails.indexOf(state.email) === -1;
    const addClicked = (e) => {
      userInteraction({ section: 'add-clicked' })(e);
      this.focus();
    };
    const onKeyDown = (e) => {
      if (addEnabled && e.keyCode === 13) {
        // enter key pressed
        addClicked(e);
      }
    };
    const noOfCollaborators = state.emails.filter(
      (e) => !state.disabled.find((email) => email === e),
    ).length;
    const ownerAPs = state.ownerAp ? (
      <small className="faint">({state.ownerAp} activity points)</small>
    ) : (
      ''
    );
    return (
      <table className="centered">
        <tbody>
          <tr>
            <td className="vertical-align-center text-align-right">
              <label className="padding-top-5">Invite Teammate</label>
            </td>
            <td>
              <input
                size="35"
                placeholder="email address"
                className="form-control set-input-height"
                onChange={emailChange}
                value={state.email}
                ref={(input) => (this._input = input)}
                onKeyDown={onKeyDown}
              />
            </td>
            <td>
              <button
                disabled={!addEnabled}
                className="btn btn-outline-dark full-width set-input-height"
                type="button"
                onClick={addClicked}
              >
                Add
              </button>
            </td>
          </tr>
          <tr>
            <td colSpan={3}>
              {!state.somethingChanged ? null : (
                <h4 className="text-align-center">
                  <label className="label highlight-text" type="label">
                    To confirm changes, click <strong>Done</strong> below
                  </label>
                </h4>
              )}
            </td>
          </tr>
          <tr>
            <td className="vertical-align-center">
              <label
                className="label pull-right label-success label-normal owner-label"
                type="label"
              >
                owner
              </label>
            </td>
            <td>
              <h5 className="padding-left-10">
                {state.ownerEmail}{' '}
                {!state.ownerIsHerokuAddon ? '' : '(via Heroku)'} {ownerAPs}
              </h5>
            </td>
          </tr>
          {collabs}
          <tr>
            <td colSpan={3}>
              <center className="padding-top-10">
                <h5>
                  <b>
                    {state.ownerIsHerokuAddon ? 'Team of: ' : 'Total users: '}
                  </b>
                  {1 + noOfCollaborators}
                </h5>
              </center>
              <hr />
              <p className="subtle">
                Teammates you add as <strong>collaborators</strong> will be able
                to access this datasource by signing in at&nbsp;
                <a href="https://trevor.io" target="_blank">
                  https://trevor.io
                </a>{' '}
                with a username/password or google account.&nbsp; They{' '}
                <strong>will not</strong> be able to see your database
                credentials or modify your underlying data in any way.
              </p>
              <p className="subtle">
                Make a teammate an <strong>admin</strong> to enable them to{' '}
                <strong>invite new teammates</strong> and{' '}
                <strong>manage your account payment method</strong>.&nbsp; They{' '}
                <strong>will not</strong> be able to see or update your database
                credentials.
              </p>
              {state.ownerIsHerokuAddon ? null : <hr />}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default ModalCollaborators;
